import React, { forwardRef, ReactNode } from 'react';
import {
  FormErrorMessage as ChakraFormErrorMessage,
  FormErrorMessageProps,
} from '@chakra-ui/react';

interface Props extends Omit<FormErrorMessageProps, `css`> {
  children: ReactNode;
}

export const FormErrorMessage = forwardRef<HTMLDivElement, Props>(
  ({ children, ...props }, ref): JSX.Element => {
    return (
      <ChakraFormErrorMessage ref={ref} {...props}>
        {children}
      </ChakraFormErrorMessage>
    );
  }
);
export type { Props as FormErrorMessageProps };
